/** Durée lisible en français : « 12,3 s », « 1 min 05 s ». */
export function formatSeconds(ms: number): string {
  const safe = Number.isFinite(ms) && ms > 0 ? ms : 0;
  const tenths = Math.round(safe / 100);
  if (tenths < 600) return `${(tenths / 10).toFixed(1).replace('.', ',')} s`;
  const seconds = Math.round(safe / 1000);
  return `${Math.floor(seconds / 60)} min ${String(seconds % 60).padStart(2, '0')} s`;
}
